export default "__VITE_ASSET__v8Vl89Y3__"